export function addOptionPrefix(optionId: number) {
  return `opt_${optionId}`;
}
